import { render, staticRenderFns } from "./steps.vue?vue&type=template&id=ec612c32&scoped=true"
import script from "./steps.vue?vue&type=script&lang=js"
export * from "./steps.vue?vue&type=script&lang=js"
import style0 from "./steps.vue?vue&type=style&index=0&id=ec612c32&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec612c32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec612c32')) {
      api.createRecord('ec612c32', component.options)
    } else {
      api.reload('ec612c32', component.options)
    }
    module.hot.accept("./steps.vue?vue&type=template&id=ec612c32&scoped=true", function () {
      api.rerender('ec612c32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/temporaryWorkerAccount/cmp/steps.vue"
export default component.exports